import * as React from "react";

import Container from "@mui/material/Container";
import { Button, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import settings from "../../Images/settings.png";
import timer from "../../Images/timer.png";
import gsxusdt from "../../Images/gsxusdt.png";
import gsxr from "../../Images/gsxr.png";
import smallusdt from "../../Images/smallusdt.png";
import smallgsx from "../../Images/smallgsx.png";
import rei from "../../Images/rei.png";

import Navbar from "../../Sections/Navbar/Index";
import Footer from "../../Sections/Footer/Index";

import { Link } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Liquidity = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openrec, setOpenrec] = React.useState(false);
  const handleOpenrec = () => setOpenrec(true);
  const handleCloserec = () => setOpenrec(false);

  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Navbar />
      <Container>
        <div className="forheight">
          <Grid container justifyContent="center">
            <Grid xs={12} sm={11} md={6} className="py-5">
              <div className=" pt-sm-3 d-flex justify-content-center">
                <div className="Ray---Connectpage---Card">
                  <div className="px-3 pt-3 Ray---Connect---Button---border">
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Link
                          className="Ray---Connect--tab-btn1"
                          style={{ textDecoration: "none" }}
                          to="./swap"
                        >
                          <Tab label="Exchange" {...a11yProps(0)} />
                        </Link>
                        <Tab
                          label="Liquidity"
                          {...a11yProps(1)}
                          className="Ray---Connect--tab-btn"
                        />
                      </Tabs>
                    </Box>
                  </div>
                  <div className="px-3 pb-3">
                    {/* when no liquidity found starts here------------------------------------------------- */}

                    <TabPanel value={value} index={1}>
                      <div className="Ray__Connect__Exchange pt-3">
                        Your Liquidity
                        <p className="Ray---connect---swap">
                          Remove Liquidity To Receive Tokens Back
                        </p>
                      </div>
                      <div className="Ray__Connect__Icons pt-3">
                        <img onClick={handleOpen} alt="" src={settings} />
                        <img
                          className="ml-2"
                          onClick={handleOpenrec}
                          alt=""
                          src={timer}
                        />
                      </div>
                      <div className="Ray---Connect---Modal---noliquidity---box">
                        <p>No Liquidity Found</p>
                        <p>Don't See A Pool You Joined?</p>
                        <Link
                          className="Rey---Connect---Modal---noliquiidty---findtokens---Button py-1 px-3 mb-2"
                          style={{ textDecoration: "none" }}
                          to="/importpool"
                        >
                          Find Other LP Tokens
                        </Link>
                      </div>
                      <Link
                        style={{ textDecoration: "none" }}
                        to="/addliquidity"
                      >
                        <Button className="Rey---Connect---SwapButton">
                          Add Liquidity
                        </Button>
                      </Link>
                    </TabPanel>
                  </div>
                  {/* when no liquidity found ENDS HERE------------------------------------------------- */}

                  {/* WITH liquidity starts here------------------------------------------------- */}
                  <div className="px-3 pb-3">
                    <TabPanel value={value} index={1}>
                      <div className="Ray__Connect__Exchange pt-3">
                        Your Liquidity
                        <p className="Ray---connect---swap">
                          Remove Liquidity To Receive Tokens Back
                        </p>
                      </div>
                      <div className="Ray__Connect__Icons pt-3">
                        <img onClick={handleOpen} alt="" src={settings} />
                        <img
                          className="ml-2"
                          onClick={handleOpenrec}
                          alt=""
                          src={timer}
                        />
                      </div>
                      <Accordion className="Ray---Connect---accordian py-2">
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography fontSize={11}>
                            <img
                              className="mr-3 Ray---Connect---Accord---icon"
                              src={gsxusdt}
                              alt=""
                            />
                            GXS/USDT
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                {" "}
                                Pooled GXS
                              </span>
                              <span style={{ color: "white" }}>
                                100{" "}
                                <img
                                  className="img-fluid"
                                  alt=""
                                  src={smallgsx}
                                />
                              </span>
                            </div>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                Pooled USDT
                              </span>
                              <span style={{ color: "white" }}>
                                1000{" "}
                                <img
                                  className="img-fluid"
                                  alt=""
                                  src={smallusdt}
                                />
                              </span>
                            </div>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                Your pool tokens
                              </span>
                              <span style={{ color: "white" }}> 72.5</span>
                            </div>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                Your pool share
                              </span>
                              <span style={{ color: "white" }}> 0.001%</span>
                            </div>
                            <Link
                              className="px-2 py-2 mt-4 Rey---Connect---RemoveLiquidity"
                              style={{ textDecoration: "none" }}
                              to="/removeliquidity"
                            >
                              Remove Liquidity
                            </Link>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion className="py-2">
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography fontSize={11}>
                            <img
                              className="mr-3 Ray---Connect---Accord---icon"
                              alt=""
                              src={gsxr}
                            />
                            GXS/REI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                {" "}
                                Pooled GXS
                              </span>
                              <span style={{ color: "white" }}>
                                100{" "}
                                <img
                                  className="img-fluid"
                                  alt=""
                                  src={smallgsx}
                                />
                              </span>
                            </div>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                Pooled REI
                              </span>
                              <span style={{ color: "white" }}>
                                1000{" "}
                                <img className="img-fluid" alt="" src={rei} />
                              </span>
                            </div>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                Your pool tokens
                              </span>
                              <span style={{ color: "white" }}> 72.5</span>
                            </div>
                            <div
                              style={{ color: "white" }}
                              className="Rey---Head---card---ModalRecent1stbox"
                            >
                              <span className="py-1" style={{ color: "white" }}>
                                Your pool share
                              </span>
                              <span style={{ color: "white" }}> 0.001%</span>
                            </div>
                            <Link
                              className="px-2 py-2 mt-4 Rey---Connect---RemoveLiquidity"
                              style={{ textDecoration: "none" }}
                              to="/removeliquidity"
                            >
                              Remove Liquidity
                            </Link>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Link style={{ textDecoration: "none" }} to="/importpool">
                        <Button className="mt-5 Rey---Connect---SwapButton">
                          Add Liquidity
                        </Button>
                      </Link>
                    </TabPanel>
                  </div>
                  {/* WITH liquidity ENDS HERE------------------------------------------------- */}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {/* Modal for recent starts here -----------------------------------------*/}
        <Modal
          className=" Modal"
          open={openrec}
          onCloserec={handleCloserec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Recent Transactions
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloserec(false)}
                >
                  X
                </button>
              </h4>

              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecentboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Send</h6>
                  <h6>-50 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span style={{ fontWeight: 300, color: "white" }}>
                    Jan 10 To: 0X024...1E61
                  </span>
                  <span style={{ fontWeight: 300, color: "white" }}>
                    {" "}
                    +50 Gxs
                  </span>
                </div>
              </div>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecent2ndboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Recieved</h6>
                  <h6> +500 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span style={{ fontWeight: 300, color: "white" }}>
                    Jan 10 To: 0X024...1E61
                  </span>
                  <span style={{ fontWeight: 300, color: "white" }}>
                    {" "}
                    +500 Gxs
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Footer />

        {/* Modal for settings starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Setting
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleClose(false)}
                >
                  X
                </button>
              </h4>
              <div
                className="Ray---Connect---Modal---fromto"
                style={{ color: "white" }}
              >
                <p>Slipage Tolerance?</p>
                <div className="Ray---settings---inputauto">
                  <Button className="Rey---settings---autobutton">auto</Button>

                  <label htmlFor="text"></label>
                  <input
                    className="Ray---Connect---Modal---Text "
                    type="number"
                    name="phonenumber"
                    id="phonenumber"
                    placeholder="2.00%"
                  />
                </div>
                <p className="mt-2 pb-2">Transaction Deadline?</p>
                <p className="Ray---Connect---Modal---TextTransaction">20</p>
                <p className="Ray---Connect---Modal---textmint">Minutes</p>
              </div>
            </div>
          </div>
        </Modal>
      </Container>
    </div>
  );
};

export default Liquidity;
